if (!customElements.get('ax-stats-tabs')) {
  customElements.define(
    'ax-stats-tabs',
    class AxStatsTabs extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
        this.syncMedia(this.querySelector('.accordion__disclosure[open]'));
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      // Accordéon exclusif : ouvrir un onglet ferme celui déjà ouvert.
      // Le custom element <accordion-disclosure> bascule "is-open" sur le clic du <summary>
      // avant que l'événement ne remonte jusqu'ici, on peut donc lire l'état final.
      onClick(event) {
        const opened = event.target.closest('accordion-disclosure');
        if (!opened || !this.contains(opened)) return;

        if (!opened.classList.contains('is-open')) {
          this.syncMedia(null);
          return;
        }

        this.querySelectorAll('accordion-disclosure.is-open').forEach((other) => {
          if (other === opened) return;
          const summary = other.querySelector('summary');
          if (summary) summary.click(); // rejoue l'animation de fermeture native du composant
        });

        this.syncMedia(opened);
        // Pas d'événement de fin d'animation exposé par <accordion-disclosure> : on attend
        // la durée de la séquence ouverture/fermeture (0.25s + 0.15s) avant de mesurer.
        setTimeout(() => this.revealFully(opened), 420);
      }

      // scrollIntoView remonte tous les conteneurs scrollables : en desktop l'onglet
      // defile dans .ax-stats__tabs-inner, en mobile c'est la page qui bouge.
      revealFully(scope) {
        scope.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }

      // Chaque bloc de contenu déclare l'image de son onglet. On la reporte sur la
      // section plutôt que de laisser le CSS lire l'attribut [open] : l'onglet qui se
      // referme le garde le temps de son animation, deux images seraient candidates.
      syncMedia(scope) {
        const root = this.closest('.ax-stats');
        if (!root) return;

        const marker = scope ? scope.querySelector('[data-ax-media]') : null;
        // Tous les onglets fermes : on garde le visuel `efficacy`, celui de Description.
        root.dataset.axActiveMedia = marker ? marker.getAttribute('data-ax-media') : 'efficacy';
        root.toggleAttribute('data-ax-active-highlight', scope != null && scope.querySelector('[data-ax-highlight]') != null);
      }
    }
  );
}
